// @ts-check
import { apiRequest } from '../../../shared/api/base';

/** @returns {Promise<import('../../../shared/api/types').AppProgressResponse>} */
export function getRoadmapProgress(studentId) {
  return apiRequest(`/app/progress/${studentId}`);
}

/**
 * Record a lesson step completion (video, quiz, or repeat).
 * @param {{ studentId: string, course: string, book: string, lessonNumber: string, step: 'video'|'quiz'|'repeat', hasVideo: boolean, hasQuiz: boolean, hasRepeat: boolean }} params
 * @returns {Promise<{ completed: boolean }>}
 */
export function postLessonStep(params) {
  return apiRequest('/app/lesson-completion', {
    method: 'POST',
    body: JSON.stringify(params),
  });
}

/**
 * Increment crown level (completion_count) for a fully-completed lesson.
 * @param {{ studentId: string, course: string, book: string, lessonNumber: string }} params
 * @returns {Promise<{ incremented: boolean }>}
 */
export function postLessonReviewComplete(params) {
  return apiRequest('/app/lesson-review-complete', {
    method: 'POST',
    body: JSON.stringify(params),
  });
}

/**
 * Batch-save per-question quiz responses for a lesson (fire-and-forget).
 * @param {{ studentId: string, course: string, book: string, lessonNumber: string, responses: Array<{ questionId: string, questionType: string, studentAnswer: string, correctAnswer: string, isCorrect: boolean }> }} params
 * @returns {Promise<{ saved: number }>}
 */
export function postQuizResponses(params) {
  return apiRequest('/app/quiz-responses', {
    method: 'POST',
    body: JSON.stringify(params),
  });
}

/**
 * Get per-step progress for a specific lesson.
 * @param {string} studentId
 * @param {string} course
 * @param {string} book
 * @param {string} lessonNumber
 * @returns {Promise<{ video_completed_at: string|null, quiz_completed_at: string|null, repeat_completed_at: string|null, has_video: number, has_quiz: number, has_repeat: number, completion_count: number }|null>}
 */
export function getLessonProgress(studentId, course, book, lessonNumber) {
  return apiRequest(`/app/lesson-progress/${studentId}/${course}/${book}/${lessonNumber}`);
}

/**
 * Status for the "categories" (Family/Activities/Countries) dashboard card.
 * A student outside the rollout gets `{ enabled: false }` and no other fields —
 * always check `enabled` before reading `completedToday`.
 * @param {string} studentId
 * @returns {Promise<import('../../../shared/api/types').CategoryLevelsResponse>}
 */
export function getCategoryLevelsStatus(studentId) {
  return apiRequest(`/app/category-levels/${studentId}`);
}
